import { useState, useCallback } from 'react';
import { ConfigService, type AssistantConfig } from '../services/configService';

export const useAssistantConfig = () => {
  const [config, setConfig] = useState<AssistantConfig | null>(null);
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState<string | null>(null);

  const loadConfig = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const data = await ConfigService.getConfig();
      setConfig(data);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to load config');
    } finally {
      setLoading(false);
    }
  }, []);

  const saveConfig = useCallback(async (newConfig: AssistantConfig) => {
    setSaving(true);
    setError(null);
    setSuccess(null);
    try {
      const result = await ConfigService.updateConfig(newConfig);
      if (result.success) {
        setConfig(newConfig);
        setSuccess(result.message || 'Settings saved successfully');
        setTimeout(() => setSuccess(null), 3000);
      } else {
        setError(result.message || 'Failed to save settings');
      }
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to save config');
    } finally {
      setSaving(false);
    }
  }, []);

  return {
    config,
    loading,
    saving,
    error,
    success,
    loadConfig,
    saveConfig,
  };
};
